// ABOUTME: useState mirrored to localStorage as JSON under a registered key.
// ABOUTME: Reads once on mount; storage that is missing, corrupt or throwing yields the default.

import type { Dispatch, SetStateAction } from "react"
import { useEffect, useState } from "react"
import type { StorageKey } from "@shared/constants/storageKeys"
import { storageService } from "@shared/services/storageService"

export const useLocalStorage = <T>(key: StorageKey, defaultValue: T): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(() => storageService.get<T>(key) ?? defaultValue)

  useEffect(() => {
    storageService.set(key, value)
  }, [key, value])

  return [value, setValue]
}
